<template>
    <div>
        <div>轮播</div>
        <div style="height:200px">
            <mt-swipe :auto="4000">
                <mt-swipe-item style="background: red">1</mt-swipe-item>
                <mt-swipe-item style="background: blue">2</mt-swipe-item>
                <mt-swipe-item style="background: green">3</mt-swipe-item>
            </mt-swipe>
        </div>
        <div>下拉刷新</div>
        <div style="width:100%;height:300px;background: #aaa;overflow-y: auto">
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded"
                         ref="loadmore">
                <ul>
                    <li v-for="item in list">{{ item }}</li>
                </ul>
            </mt-loadmore>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                topStatus: "",
                list: ["激发了短斤少两", "激发了短斤少两", "激发了短斤少两",  "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两", "激发了短斤少两"]
            }
        },
        methods: {
            initSwiper: function () {

            },
            loadTop: function () {
                let _this = this;
                setTimeout(() => {
                    _this.$refs.loadmore.onTopLoaded();
                }, 1000)
            },
            loadBottom: function () {
                let _this = this;
                setTimeout(() => {
                    this.allLoaded = true;// if all data are loaded
                    this.$refs.loadmore.onBottomLoaded();
                }, 1000)
            }
        },
        mounted() {
            this.initSwiper();
        }
    }

</script>

<style lang="scss">
    .swiper-wrapper {
        .swiper-slide {
            background: #aaa;
            margin: auto;
            line-height: 200px;
            text-align: center;
        }
    }
</style>
